import { useApp } from '../context/AppContext';
import { Sun, Moon } from './Icons';

export default function ThemeToggle() {
  const { theme, setTheme } = useApp();
  const isDark = theme === 'dark';

  return (
    <button
      id="theme-toggle-btn"
      onClick={() => setTheme(isDark ? 'light' : 'dark')}
      className="p-2.5 rounded-full transition-all duration-300 bg-white/40 dark:bg-neutral-800/60 hover:bg-rose-100/60 dark:hover:bg-neutral-700/60 text-rose-500 dark:text-rose-300 border border-white/40 dark:border-neutral-700/40 cursor-pointer"
      title={isDark ? "Light Mode" : "Dark Mode"}
    >
      {isDark ? <Sun className="w-5 h-5 animate-pulse" /> : <Moon className="w-5 h-5" />}
    </button>
  );
}
